import GLOBALS from '../utils/Constants';
import UserService from './users-service';

class ClientService{
  static sharedInstance = ClientService.sharedInstance ? this.sharedInstance : new ClientService();

  constructor(){
    //initialize
    this.credentials = UserService.sharedInstance.getStoredCredentials();
    this.auth_username = this.credentials.username;
    this.license = this.credentials.license;
    this.token = this.credentials.token;
  }

  getUpdatedCrendetials(){
    this.credentials = UserService.sharedInstance.getStoredCredentials();
    this.auth_username = this.credentials.username;
    this.license = this.credentials.license;
    this.token = this.credentials.token;
  }

  getClients = async() =>{
    try{
      this.getUpdatedCrendetials();

      const {loginResponse} = this.credentials;
      const data = loginResponse.data[0];
      const {token_data} = loginResponse;

      const {User_ID,User_License} = data;
      const {token} = token_data;

      const param = UserService.sharedInstance.urlEncodeParams({
        token,
        license:User_License,
        auth_username:User_ID
      });

      const response = await fetch(GLOBALS.GET_ALL_CLIENTS_API + '&' + param);
      const json = await response.json();

      UserService.sharedInstance.checkIfTokenIsValid(json);

      return json;
    }catch(err){
      console.error('Error',err);

      alert(err.message);
    }
  }

  disableClient = async(id) =>{
    try{
      this.getUpdatedCrendetials();

      const {loginResponse} = this.credentials;
      const data = loginResponse.data[0];
      const {token_data} = loginResponse;

      const {User_ID,User_License} = data;
      const {token} = token_data;

      const option = {
        method:'POST',
        headers:{
          'Content-Type': 'application/x-www-form-urlencoded',
        },body:UserService.sharedInstance.urlEncodeParams({
          id,
          token,
          status:'disable',
          license:User_License,
          auth_username:User_ID,
        })
      }
      
      const response = await fetch(GLOBALS.UPDATE_CLIENT_STATUS_API,option);
      const json = await response.json();

      UserService.sharedInstance.checkIfTokenIsValid(json);

      return json;
    }catch(err){
      console.error('Error',err);
    }
  }

  newClient = async(client) =>{
    try{
      this.getUpdatedCrendetials();
      const {loginResponse} = this.credentials;
      const data = loginResponse.data[0];
      const {token_data} = loginResponse;

      const {User_ID,User_License} = data;
      const {token} = token_data;

      const param = {
        ...client,
        token,
        license:User_License,
        auth_username:User_ID,
      }
      const option = {
        method:'POST',
        headers:{
          'Content-Type': 'application/x-www-form-urlencoded',
        },body:UserService.sharedInstance.urlEncodeParams(param)
      }

      const response = await fetch(GLOBALS.ADD_CLIENT_API,option);
      const json = await response.json();

      UserService.sharedInstance.checkIfTokenIsValid(json);

      return json;
    }catch(err){
      console.error('Error:',err);
    }
  }

  updateClient = async(id,update) =>{
    try{
      this.getUpdatedCrendetials();

      const {loginResponse} = this.credentials;
      const data = loginResponse.data[0];
      const {token_data} = loginResponse;

      const {User_ID,User_License} = data;
      const {token} = token_data;

      const param = {
        ...update,
        id,
        token,
        license:User_License,
        auth_username:User_ID,
      };

      const option = {
        method:'POST',
        headers:{
          'Content-Type': 'application/x-www-form-urlencoded',
        },body:UserService.sharedInstance.urlEncodeParams(param)
      }

      const response = await fetch(GLOBALS.UPDATE_CLIENT_API,option);
      const json = await response.json();

      UserService.sharedInstance.checkIfTokenIsValid(json);

      return json;
    }catch(err){
      console.error('Error:',err);

      return {
        success:0,
        code_error:'client_error',
        message:err.message
      }
    }
  }

  getClientBySub = async(id) =>{
    this.getUpdatedCrendetials();

    const {loginResponse} = this.credentials;
    const data = loginResponse.data[0];
    const {token_data} = loginResponse;

    const {User_ID,User_License} = data;
    const {token} = token_data;

    const param = UserService.sharedInstance.urlEncodeParams({
      id,
      token,
      license:User_License,
      auth_username:User_ID
    });

    let response = await fetch(GLOBALS.GET_CLIENT_BY_SUB_API + '&' + param, {
        method: 'GET',
        headers: {
            'Content-Type':'application/x-www-form-urlencoded',
        }
    });
    let responseJson = await response.json();
    try {
        UserService.sharedInstance.checkIfTokenIsValid(responseJson); //need to check if token is valid
        return responseJson;
    } catch (error) {
        console.error(error);
    }
  }
}

export default ClientService;